import { render, staticRenderFns } from "./veStuAssocInfoShow.vue?vue&type=template&id=b934e8a2&scoped=true"
import script from "./veStuAssocInfoShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocInfoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b934e8a2",
  null
  
)

export default component.exports